<div class="layout-container">
  @if (user$ | async; as user) {
    @if (user.customers.length > 0) {
      <app-customer-header/>
    } @else {
      <!-- No data-scope entries yet (e.g. an onboarding account with no locations set up) —
           app-customer-header assumes at least one location, so fall back to the plain header. -->
      <app-header></app-header>
    }
  }
  <router-outlet></router-outlet>
  @if (shouldShowOnboarding$ | async) {
    <app-onboarding-overlay></app-onboarding-overlay>
  }
</div>
